export const colors = {
    LandingPage_Background: '#FFFFFF',
    LandingPage_Description: '#4B5563',
    Button_Primary: '#E5232A',
    Button_Secondary: '#111111', 
    Header_Background: "#FFFFFF",
    Header_Content: '#111111',
    Black: '#111111',
    Header: '#111111',
    Header_Text: "#FFFFFF",
    Header_Text_back: "#1F2937",
    Table_Header: '#F3F4F6',
    Action_Button_Back: '#E5232A',
    ALERT_BUTTON_GOTO_COLOR: "#E5232A",
    ALERT_BUTTON_CLOSE_COLOR:  "#6B7280",
    HEADER: '#111111',
    SHADOW_LIGHT: "rgba(0, 0, 0, 0.08)",
    CAR_BOX_EVEN:'#F9FAFB',
    CAR_BOX_ODD:'#FFFFFF',
    CARD_LABEL:"#111111",
    CARD_DETAIL:"#F3F4F6",
    STATUS_COMPLETE:"#10B981",
    STATUS_CANCELED:"#EF4444",
    STATUS_PENDING:"#F59E0B",
    ROW_SELECTED:"#F3F4F6",
    TABLE_BORDER:"#E5E7EB",
    SUB_2:"#E5232A",
    WALLET_CARD:"#111111",
    WALLET_CARD_SHADOW:"rgba(0, 0, 0, 0.15)",
    FACEBOOK_COLOR:"#1877F2",
    BLUE:"#2563EB",
    
    TAXIPRIMARY: "#111111",
    TAXISECONDORY: "#E5232A",

    DELIVERYPRIMARY: "#E5232A",
    DELIVERYSECONDORY: "#F3F4F6",

    BIDTAXIPRIMARY: "#111111",
    BIDTAXISECONDORY: "#E5232A",

    TRANSPARENT: "transparent",
    WHITE: "#ffffff",
    BLACK: "#111111",
    RED: "#E5232A",
    GREEN: "#10B981",
    YELLOW: "#F59E0B",
    VIOLET:"#8B5CF6",
    SHADOW: "rgba(0, 0, 0, 0.12)",
}